import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-gestaoMarcas',
    templateUrl: './gestaoMarcas.component.html',
    styleUrls: ['./gestaoMarcas.component.less'],
    standalone: false
})
export class GestaoMarcasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
